<template>
    <div id="assign-order">
<div id="assign-heading">
    <h2>Assign Order</h2>
</div>
<div id="form">
    <div id="form-row-1">
        <input type="text" class="input-1" placeholder="Customer Name" v-model="customer_name">
        <input type="text" class="input-1" placeholder="Customer Phone" v-model="customer_phone">
        <input type="text" class="input-1" placeholder="Customer Address" v-model="address_1">
        <input type="text" class="input-1" placeholder="Postcode" v-model="post_code">
        <input type="text" class="input-1" placeholder="Landmark" v-model="landmark">
    </div>
    <div id="assign-heading">
        <h2>Order Details</h2>
    </div>
    <div id="form-row-3">
        <input type="number" class="input-1" placeholder="No. of bags" v-model="bags" >
        <payment-field></payment-field>
        <input type="text" class="input-1" placeholder="Delivery Items" v-model="delivery_items">
        <input type="text" class="input-1" placeholder="Delivery Instructions" v-model="instructions">
        
    </div>
    <div id="assign-heading">
        <h2>Enter Order Value</h2>
    </div>
    <div id="form-row-2">
        <div id="pricing">
            <input type="number" class="input-min" placeholder="£0.00" v-model="orderValue">
        <h4 id="price-info1">In case of cash delivery this amount will be collected by the driver.</h4>
        </div>
        <h3>Price</h3>
        <div id="pricing">
            <h2>£0.00</h2>
        <h4 id="price-info2">Price will be auto-generated
            according to the distance</h4>
        </div>
    </div>
    
</div>
<submit-button Text="Assign Order now"></submit-button>
    </div>
</template>

<script>
import SubmitButton from '../home/submit-button.vue'
import PaymentField from '../home/payment-field.vue'
export default {
    components:{SubmitButton,PaymentField},
    data(){
        return{
            customer_phone:'',
            customer_name:'',
            post_code:'',
            address_1:'',
            landmark:'',
            delivery_items:'',
            payment:'',
            instructions:'',
            bags:'',
            price:'',
            orderValue:''
        }
    },
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter&display=swap');
#assign-order{
    width:100vw;
    margin-top:10px;
    height: auto;
    overflow-x:hidden ;
}
#assign-order::-webkit-scrollbar{
    display: none;
}

@media only screen and (max-width:480px){
    #assign-heading{
        padding-left:8vw;
        padding-top:2vh;
    }
    #assign-heading h2{
        color: #413F3F;
font-family: Inter;
font-size: 18px;
font-style: normal;
font-weight: 600;
line-height: normal;
letter-spacing: 0.2px;
margin-bottom:15px;
    }

#form{
    margin-top:2vh;
}
.input-1,
    .input-1:focus,
    .input-1::selection{
        width:90vw;
        margin-left:5vw;
        height:54px;
        border-radius: 30px;
background: #FFF;
box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.25);
margin-bottom:24.52px;
border:none;
outline:none;
padding-left:20px;
color: #181818;
font-family: Inter;
font-size: 18px;
font-style: normal;
font-weight: 500;
line-height: normal;
letter-spacing: 0.2px;
    }
    .input-1::placeholder{
        color: #8D8D8D;
font-family: Inter;
font-size: 18px;
font-style: normal;
font-weight: 500;
line-height: normal;
letter-spacing: 0.2px;
    }
    .input-min,
    .input-min:focus,
    .input-min::selection{
        width:30vw;
        height:54px;
        margin-left:-2vw;
        border-radius: 30px;
background: #FFF;
box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.25);
border:none;
outline:none;
padding-left:20px;
color: #181818;
font-family: Inter;
font-size: 18px;
font-style: normal;
font-weight: 500;
line-height: normal;
letter-spacing: 0.2px;
margin-right:0px;
    }
    .input-min::placeholder{
        color: #8D8D8D;
font-family: Inter;
font-size: 18px;
font-style: normal;
font-weight: 500;
line-height: normal;
letter-spacing: 0.2px;
    }
    #form-row-2{
        padding-left:8vw;
        margin-bottom:15px;
    }
#form-row-2 h3{
    color: #413F3F;
    font-family: Inter;
    font-size: 15px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    letter-spacing: 0.317px;
}
#pricing{
    display: inline-flex;
    margin-top:10px;
    margin-bottom:20px;
}
#form-row-2 h2{
    color: var(--brand-color, #25AD34);
font-family: Inter;
font-size: 22.807px;
font-style: normal;
font-weight: 500;
line-height: normal;
letter-spacing: 0.228px;
}
#price-info1{
    color: #8D8D8D;
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    letter-spacing: 0.2px;
    width:60vw;
    margin-top:0px;
    margin-left:4vw;
}
#price-info2{
    color: #8D8D8D;
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    letter-spacing: 0.2px;
    width:60vw;
    margin-top:-1vh;
    margin-left:16vw;
}
}
@media only screen and (min-width:481px) and (max-width:960px){
    #assign-heading{
        padding-left:3vw;
        padding-top:2vh;
    }
    #assign-heading h2{
        color: #413F3F;
font-family: Inter;
font-size: 28px;
font-style: normal;
font-weight: 600;
line-height: normal;
letter-spacing: 0.2px;
margin-bottom:15px;
    }

#form{
    margin-top:2vh;
}
#form-row-1,
#form-row-3{
    width:97vw;
    display: grid;
    padding-left:3vw;
    grid-template-columns: repeat(2,47vw);
    overflow-x:hidden ;
}
.input-1,
.input-1:focus,
.input-1::selection{
    width:45vw;
    height:67px;
    border-radius: 30px;
background: #FFF;
box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.25);
margin-bottom:41.52px;
border:none;
outline:none;
padding-left:20px;
color: #181818;
font-family: Inter;
font-size: 24px;
font-style: normal;
font-weight: 500;
line-height: normal;
letter-spacing: 0.2px;
}
.input-1::placeholder{
    color: #8D8D8D;
font-family: Inter;
font-size: 19px;
font-style: normal;
font-weight: 500;
line-height: normal;
letter-spacing: 0.2px;
}
.input-min,
    .input-min:focus,
    .input-min::selection{
        width:45vw;
        height:67px;
        margin-left:2vw;
        border-radius: 30px;
background: #FFF;
box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.25);
border:none;
outline:none;
padding-left:20px;
color: #181818;
font-family: Inter;
font-size: 24px;
font-style: normal;
font-weight: 500;
line-height: normal;
letter-spacing: 0.2px;
margin-right:0px;
    }
    .input-min::placeholder{
        color: #8D8D8D;
font-family: Inter;
font-size: 24px;
font-style: normal;
font-weight: 500;
line-height: normal;
letter-spacing: 0.2px;
    }
#form-row-2{
    padding-left:1.8vw;
    padding-top:0px;
    margin-bottom:4vh
}
#form-row-2 h3{
    color: #131313;
font-family: Inter;
font-size: 24px;
font-style: normal;
font-weight: 500;
line-height: normal;
letter-spacing: 0.2px;
margin-bottom:7px;
margin-left:3vw;
}
#form-row-2 h2{
    color: var(--brand-color, #25AD34);
font-family: Inter;
font-size: 30px;
font-style: normal;
font-weight: 400;
line-height: normal;
letter-spacing: 0.2px;
margin-left:3vw;
}
#price-info1{
    color: #8D8D8D;
    font-family: Inter;
    font-size: 24px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    letter-spacing: 0.2px;
    width:40vw;
    float: left;
    margin-left:5vw;
    margin-top:-.5vh;
}
#price-info2{
    color: #8D8D8D;
    font-family: Inter;
    font-size: 24px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    letter-spacing: 0.2px;
    width:40vw;
    float: left;
    margin-left:39vw;
    margin-top:-1.5vh;
}
#pricing{
    display: inline-flex;
    margin-bottom:20px;
}
}
@media only screen and (min-width:961px){

#assign-heading{
    padding-left:5vw;
    padding-top:2vh;
}
#assign-heading h2{
    color: #413F3F;
font-family: Inter;
font-size: 24px;
font-style: normal;
font-weight: 500;
line-height: normal;
letter-spacing: 0.2px;
margin-bottom:20px;
}
#form{
margin-top:4vh;
}
#form-row-1,
#form-row-3{
width:90vw;
margin-bottom:0vh;
display: grid;
padding-left:5vw;
padding-right:5vw;
grid-template-columns: repeat(3,20vw);
overflow-x:hidden ;
column-gap:10vw;
overflow-y: auto;
}
#form-row-1::-webkit-scrollbar,
#form-row-2::-webkit-scrollbar{
    display: none;
}
.input-1,
.input-1:focus,
.input-1::selection{
    width:20vw;
    height:47px;
    border-radius: 30px;
background: #FFF;
box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.15);
margin-bottom:6.5vh;
border:none;
outline:none;
padding-left:20px;
color: #181818;
font-family: Inter;
font-size: 18px;
font-style: normal;
font-weight: 500;
line-height: normal;
letter-spacing: 0.2px;
}
.input-1::placeholder{
    color: #8D8D8D;
font-family: Inter;
font-size: 18px;
font-style: normal;
font-weight: 500;
line-height: normal;
letter-spacing: 0.2px;
}
.input-min,
.input-min:focus,
.input-min::selection{
    width:20vw;
    height:47px;
    border-radius: 30px;
background: #FFF;
box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.15);
margin-bottom:6.5vh;
border:none;
outline:none;
padding-left:20px;
color: #181818;
font-family: Inter;
font-size: 20px;
font-style: normal;
font-weight: 500;
line-height: normal;
letter-spacing: 0.2px;
}
.input-min::placeholder{
    color: #8D8D8D;
font-family: Inter;
font-size: 20px;
font-style: normal;
font-weight: 500;
line-height: normal;
letter-spacing: 0.2px;
}
#form-row-2{
padding-left:5vw;
padding-top:0px;
padding-top:3vh;
margin-bottom:4.9vh
}
#form-row-2 h3{
color: #111010;
font-family: Inter;
font-size: 24px;
font-style: normal;
font-weight: 500;
line-height: normal;
letter-spacing: 0.2px;
margin-bottom:7px;
margin-left:1vw;
}
#form-row-2 h2{
    color: var(--brand-color, #25AD34);
font-family: Inter;
font-size: 30px;
font-style: normal;
font-weight: 400;
line-height: normal;
letter-spacing: 0.2px;
margin-left:1vw;
}
#pricing{
    display: inline-flex;
}
#price-info1{
color: #8D8D8D;
font-family: Inter;
font-size: 16px;
font-style: normal;
font-weight: 500;
line-height: normal;
letter-spacing: 0.2px;
width:12vw;
float:left;
margin-left:3vw;
margin-top:-1vh;
}
#price-info2{
    color: #8D8D8D;
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    letter-spacing: 0.2px;
    width:12vw;
    float:left;
    margin-left:4vw;
    margin-top:-3vh;
    }
}

</style>